import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Grid } from '@elliemae/ds-basic/Grid';
import { useTheme } from '@elliemae/ds-system';
import DSTruncatedTooltipText from '@elliemae/ds-basic/TruncatedTooltipText';
import { CellWrapper, ValueWrapper } from './styled.js';
import 'styled-components';

var CellWithAddons = function CellWithAddons(_ref) {
  var leftAddon = _ref.leftAddon,
      keepLeftPadding = _ref.keepLeftPadding,
      rightAddon = _ref.rightAddon,
      badgeAddon = _ref.badgeAddon,
      highLight = _ref.highLight,
      isEdit = _ref.isEdit,
      editComponent = _ref.editComponent,
      value = _ref.value,
      neutralText = _ref.neutralText,
      metaData = _ref.metaData;
  var theme = useTheme();
  var hasLeftAddon = !!leftAddon || keepLeftPadding;
  var hasRightAddon = !!rightAddon && !isEdit;
  var cols = [1];
  var shouldBeGray = neutralText || get(metaData, 'rowData.customRowProps.neutralText');
  if (hasLeftAddon) cols.unshift('auto');
  if (hasRightAddon) cols.push('auto');
  return /*#__PURE__*/React.createElement(CellWrapper, {
    noPadding: hasLeftAddon || badgeAddon || highLight || hasRightAddon,
    hasLeftAddon: hasLeftAddon,
    hasRightAddon: hasRightAddon,
    badgeAddon: badgeAddon,
    highLight: highLight
  }, /*#__PURE__*/React.createElement(Grid, {
    height: "100%",
    cols: cols
  }, hasLeftAddon && /*#__PURE__*/React.createElement(Grid, {
    alignItems: "center",
    pl: theme.space.xxs,
    pr: theme.space.xxs,
    width: keepLeftPadding ? '32px' : undefined
  }, hasLeftAddon && leftAddon), /*#__PURE__*/React.createElement(Grid, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ValueWrapper, {
    grayText: shouldBeGray
  }, isEdit ? editComponent : /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    value: value
  }))), hasRightAddon && /*#__PURE__*/React.createElement(Grid, {
    alignItems: "center",
    pl: theme.space.xxs
  }, rightAddon)));
};
CellWithAddons.propTypes = {
  /** Text to render inside the cell */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Left Icon */
  leftAddon: PropTypes.element,

  /** keep the left spacing even if no left addons is addded */
  keepLeftPadding: PropTypes.bool,

  /** Right Icon Button or Dropdown */
  rightAddon: PropTypes.element,

  /** TextBox/InputMask/ComboBox */
  editComponent: PropTypes.element,

  /** if is true it will show editComponent */
  isEdit: PropTypes.bool,

  /** Shows a blue mark in the top left corner */
  badgeAddon: PropTypes.bool,

  /** change background color to light blue */
  highLight: PropTypes.bool,

  /** change text color to light gray */
  neutralText: PropTypes.bool,

  /** data grid meta-information */
  metaData: PropTypes.shape({
    className: PropTypes.string,
    column: PropTypes.object,
    columnIndex: PropTypes.number,
    index: PropTypes.number,
    isScrolling: PropTypes.bool,
    key: PropTypes.string,
    parentRowData: PropTypes.any,
    property: PropTypes.string,
    registerFocus: PropTypes.func,
    rowData: PropTypes.object,
    rowIndex: PropTypes.number,
    rowKey: PropTypes.string,
    style: PropTypes.object
  })
};

export { CellWithAddons };
//# sourceMappingURL=CellWithAddons.js.map
